import i18n from '../../../i18n'

/**
 * Returns the current language selected
 * @returns {object} with selected language set to true
 */
export function getLanguage() {
  const currentLanguage = i18n.getCurrentLocale()
  const isJP = currentLanguage === 'ja' || currentLanguage === 'ja-JP'

  const isAU = currentLanguage === 'en-AU'

  const isCA = currentLanguage === 'en-CA'

  const isDE = currentLanguage === 'de-DE'

  const isFr = currentLanguage === 'fr-CA'

  const isUS = currentLanguage === 'en-US'
  return { isJP, isAU, isCA, isDE, isUS, isFr }
}
